import WebOperationEquipmentModelBase from '../_generated/modelBases/web-operation-equipment-model-base';

export default class WebOperationEquipmentModel extends WebOperationEquipmentModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
